import React, { useState, useContext } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from "@material-ui/core";

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";


const AddUser = (props) => {
  const [newUser, setNewUser] = useState({ name: "", email: "", role: "tippgeber", password: "" });
  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);
  const isBackoffice = props.currentUserRole === "backoffice";

  const addUser = () => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/users`,
      data: newUser,
      method: 'post',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        if (props.newUserCallback)
          props.newUserCallback()

        props.setAddUserDialogOpen(false);
        setNewUser({ name: "", email: "", role: "tippgeber", password: "" });
        pageContext.setInfoMessage(
          "Erledigt! " +
          newUser.name +
          " wurde als Benutzer angelegt."
        );
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Benutzer konnte nicht angelegt werden!");
      });

  }

  return (
    <Dialog
      open={props.addUserDialogOpen === true}
      onClose={() => {
        props.setAddUserDialogOpen(false);
      }}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Neuer Benutzer</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Gib die Daten des neuen Benutzers an.
        </DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Name"
              name="name"
              id="name"
              value={newUser.name ? newUser.name : ""}
              required={true}
              fullWidth
              onChange={(e) => setNewUser({ ...newUser, [e.target.name]: e.target.value })}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="E-Mail"
              name="email"
              id="email"
              value={newUser.email ? newUser.email : ""}
              onChange={(e) => setNewUser({ ...newUser, [e.target.name]: e.target.value })}
              type="email"
              required={true}
              fullWidth
              error={newUser.errors && newUser.errors.email}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Passwort"
              name="password"
              id="password"
              value={newUser.password ? newUser.password : ""}
              onChange={(e) => setNewUser({ ...newUser, [e.target.name]: e.target.value })}
              type="password"
              required={true}
              fullWidth
              error={newUser.errors && newUser.errors.password}
              helperText="mindestens 10 Zeichen"
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
            >
              <InputLabel id="role-label">Rolle</InputLabel>
              <Select
                labelId="role-label"
                name="role"
                id="role"
                fullWidth
                value={newUser.role ? newUser.role : "tippgeber"}
                onChange={(e) => setNewUser({ ...newUser, [e.target.name]: e.target.value })}
              >
                <MenuItem value="tippgeber">Tippgeber</MenuItem>
                <MenuItem value="agent">Agent</MenuItem>
                <MenuItem value="backoffice">Backoffice</MenuItem>
                {!isBackoffice && <MenuItem value="administrator">Administrator</MenuItem>}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.setAddUserDialogOpen(false);
          }}
          variant="outlined"
          color="primary"
        >
          Abbrechen
        </Button>
        <Button
          onClick={() => {
            addUser();
          }}
          variant="outlined"
          color="primary"
          disabled={
            newUser.name === ""
            || newUser.email === ""
            || newUser.password.length < 10
          }
        >
          Neuen Benutzer anlegen
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default AddUser;